import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommunityLotteryRun } from 'src/app/services/lottery.service';

export interface SubsidyPatternViewData {
  levelLabel: string;
  name: string;
  financialYear?: string;
  goid?: string;
  scheme?: string;
  component?: string;
  product?: string;
 
  remainingTarget: number;
  remainingSubsidyAmount: number;
  rows: CommunityLotteryRun[];
}

interface SubsidyPatternDisplayRow {
  communityName: string;
  targetCount: number;
  applicationCount: number;
  selectedCount: number;
  remainingCount: number;
  bold?: boolean;
}

@Component({
  selector: 'app-subsidy-pattern-view',
  templateUrl: './subsidy-pattern-view.component.html',
  styleUrls: ['./subsidy-pattern-view.component.scss']
})
export class SubsidyPatternViewComponent {

  constructor(
    public dialogRef: MatDialogRef<SubsidyPatternViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubsidyPatternViewData
  ) { }

  get displayRows(): SubsidyPatternDisplayRow[] {
    const rows: SubsidyPatternDisplayRow[] = (this.data.rows || []).map(r => ({
      communityName: r.communityName,
      targetCount: r.targetCount,
      applicationCount: r.applicationCount,
      selectedCount: r.selectedCount,

      remainingCount: Math.max(0, r.targetCount - r.selectedCount)
    }));

    rows.push({
      communityName: 'Total',
      targetCount: rows.reduce((sum, r) => sum + r.targetCount, 0),
      applicationCount: rows.reduce((sum, r) => sum + r.applicationCount, 0),
      selectedCount: rows.reduce((sum, r) => sum + r.selectedCount, 0),
      remainingCount: rows.reduce((sum, r) => sum + r.remainingCount, 0),
      bold: true
    });

    return rows;
  }

 
  get remainingTarget(): number {
    const total = this.displayRows.find(r => r.communityName === 'Total');
    return total ? total.remainingCount : 0;
  }

  pct(value: number, base: number): string {
    if (!base) {
      return '0.00';
    }
    return ((value / base) * 100).toFixed(2);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
